import { render, staticRenderFns } from "./ABigScreemBottom.vue?vue&type=template&id=5f49c022&scoped=true&"
import script from "./ABigScreemBottom.vue?vue&type=script&lang=js&"
export * from "./ABigScreemBottom.vue?vue&type=script&lang=js&"
import style0 from "./ABigScreemBottom.vue?vue&type=style&index=0&id=5f49c022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f49c022",
  null
  
)

export default component.exports